import React from "react";
import { navLinks } from "../constants/navLinks";
import { graphql, Link, useStaticQuery } from "gatsby";

const Footer = () => {
  // return (
  //   <footer className="dark:bg-[#141624] bg-[#b2d8b1] secondary p-normal text-start mt-widest"></footer>
  // )

  const data = useStaticQuery(graphql`
    query {
      allWpCategory {
        nodes {
          id
          name
        }
      }
    }
  `);

  const year = new Date().getFullYear();
  return (
    <footer className="dark:bg-[#141624]j bg-[#b2d8b1] secondary p-normal text-start mt-thin">
      <div className="lg:w-[1264px] m-auto ">
        {/* <NewsLetter /> */}
        <section className="flex flex-col md:flex-row md:justify-start md:gap-x-40 gap-y-6">
          <div>
            <h3 className="mb-2 text-[24px] ">Quick Links</h3>
            <ul className="">
              {navLinks.map((item, index) => (
                <li
                  className="dark:text-[#BABABF], text-[#666666] text-[16px]"
                  key={index}
                >
                  <Link to={item.link} aria-label={`Navigate to ${item.name}`}>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="mb-2 text-[24px]">Categories</h3>
            <ul className="">
              {data.allWpCategory.nodes.map((item, index) => (
                <li
                  className="dark:text-[#BABABF], text-[#666666] text-[16px]"
                  key={index}
                >
                  {/* I will implement search by category later */}
                  {/* <Link to={item.link} className="pointer-events-none">{item.name}</Link> */}
                  {item.name}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <hr className="my-6 bg-black_primary" />
        <div>
          <ul className="flex flex-col">
            <li className="dark:text-[#BABABF], text-[#666666] text-[16px]">
              <Link to={"/privacy-policy"}> Privacy Policy </Link>
            </li>
            <li className="dark:text-[#BABABF], text-[#666666] text-[16px]">
              <Link to={"/terms-of-use"}> Terms of Use </Link>
            </li>
          </ul>
        </div>
        <section className="flex flex-col text-[16px] mt-thin w-full">
          <div className="w-full">
            <p className="mb-thinner break-words">
              Designed and Coded with ❤️ by
              <a href="https://www.itsmedagui.com"> MedAgui.</a>
            </p>
            <p className="break-words">GardnHub {year} All rights reserved</p>
          </div>
        </section>
      </div>
    </footer>
  );
};

export default Footer;
